import { render, staticRenderFns } from "./GroupEditView.vue?vue&type=template&id=22af7044&scoped=true"
import script from "./GroupEditView.vue?vue&type=script&lang=ts"
export * from "./GroupEditView.vue?vue&type=script&lang=ts"
import style0 from "./GroupEditView.vue?vue&type=style&index=0&id=22af7044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af7044",
  null
  
)

export default component.exports